<div class="ts-badge ts-badge--{{ type }}" [class.floating]="floating">
  {{ value }}
</div>
